export class Task {
  id: string = '';
  carId: string = '';
  name: string = '';
  start: string = '';
  end: string = '';
  plateNumber?: string = '';
  /**
   * A css custom class for the task chart bar
   */
  custom_class?: string;

  constructor(options: Partial<Task> = {}) {
    Object.assign(this, options);
  }

  private _dependencies: string[] | string = [];

  get dependencies(): string[] | string {
    return this._dependencies;
  }

  set dependencies(value: string[] | string) {
    this._dependencies = Array.isArray(value)
      ? value
      : value
          .split(',')
          .map((t) => t.trim())
          .filter(Boolean);
  }

  /**
   * Progress in percentage
   */
  private _progress: number = 0.52;

  get progress() {
    return this._progress || 0.52;
  }

  set progress(value) {
    this._progress = value || 0.52;
  }

  setDependencies(value: string | string[]) {
    this._dependencies = Array.isArray(value) ? value : value.split(',').map((d) => d.trim());
  }
}
